import { useEffect, useLayoutEffect, useRef, useState } from 'react'

const adarshSharma = 'https://blueberry.azureedge.net/WillMars/adarsh-sharma.avif'
const anuraagKaul = 'https://blueberry.azureedge.net/WillMars/anuraag-kaul.avif'
const babuPaul = 'https://blueberry.azureedge.net/WillMars/babu-t-paul.avif'
const chandrasekaranRamakrishnan = 'https://blueberry.azureedge.net/WillMars/chandrasekaran-ramakrishnan.avif'
const kaushikiKaul = 'https://blueberry.azureedge.net/WillMars/kaushiki-kaul.avif'
const pRajaram = 'https://blueberry.azureedge.net/WillMars/p-rajaram.avif'
const swapnilTrivedy = 'https://blueberry.azureedge.net/WillMars/swapnil-trivedy.avif'

const profiles = [
  {
    name: 'Adarsh Sharma',
    role: 'Founder, Chairman & Managing Director — Tanzania | Founder — Kenya',
    image: adarshSharma,
    imagePosition: 'center top',
    badge: '',
    location: 'Tanzania & Kenya',
    contacts: [
      { href: 'tel:+255789886635', label: '+255 789 88 66 35' },
      { href: 'mailto:adarsh@willmarsre.com', label: 'adarsh@willmarsre.com' },
    ],
    paragraphs: [
      'Mr. Adarsh Sharma has over 42 years of experience in insurance of which he has spent 19 years with Tanzanian market. He had served the industry as a primary insurer for the last 33 years and last 9 years as an insurance broker. He has undergone advanced trainings in Aviation & Oil and Energy Insurance programs in UK apart from other trainings in different insurance institutes in India. His academic qualification is Master in Public Administration and Post Graduate Diploma in Personnel Management and Associateship from Insurance Institute of India. Other areas of his interest and expertise include Project Insurance, Marine Insurance, Liability Insurance, Terrorism Cover etc.',
    ],
  },
  {
    name: 'P. Rajaram',
    role: 'Director — Tanzania',
    image: pRajaram,
    badge: '',
    location: 'Tanzania',
    contacts: [
      { href: 'tel:+919769781695', label: '+91 9769781695' },
      { href: 'tel:+255685645935', label: '+255 685 645 935' },
      { href: 'mailto:rajaram@willmarsre.com', label: 'rajaram@willmarsre.com' },
    ],
    paragraphs: [
      'Mr. Rajaram has worked in insurance industry for more than 37 years. He started his insurance career as a part of the Regulator before being associated with international insurers like Tokio Marine, Sompo Japan and QBE, Australia. He has also served in Tanzanian market over 7 years. He has undergone specialized training in Engineering Insurances and was a part of the senior management Team in setting up three joint ventures in India.',
      'His areas of specialization include devising of Reinsurance programs, formation of technical pools, large risk inspections, Liability Insurances etc.',
    ],
  },
  {
    name: 'Alfred F. Crasto',
    role: 'Managing Director — Kenya',
    initials: 'AC',
    badge: '',
    location: 'Kenya',
    contacts: [
      { href: 'tel:+254722529112', label: '+254 722 529 112' },
      { href: 'mailto:alfred@willmarsre.com', label: 'alfred@willmarsre.com' },
    ],
    paragraphs: [
      'Alfred F. Crasto is a Nairobi-based businessman originally from Kemmannu, Karnataka. He is setup with Morgan Forex Bureau and Interbuild Limited. Beyond business, he founded Earth Angels Kemmannu, a community welfare initiative, and supports education and sports activities in Kemmannu and the East African Indian community.',
    ],
  },
  {
    name: 'Anuraag Kaul',
    role: 'Director — Kenya & Tanzania',
    image: anuraagKaul,
    imagePosition: 'center top',
    imageTranslateY: -50,
    badge: '',
    location: 'Kenya & Tanzania',
    contacts: [
      { href: 'tel:+919818553910', label: '+91 98185 53910' },
      { href: 'mailto:anuraag@willmarsre.com', label: 'anuraag@willmarsre.com' },
    ],
    paragraphs: [
      'With over 38 years of experience as an underwriter, insurance and reinsurance broker, and claims consultant, Anuraag Kaul is a seasoned insurance and risk-management professional with a global network spanning Mexico, Africa, Central Asia and Singapore.',
      'He has advised national and international clients—including corporations, insurers, brokers and surveyors—on meaningful insurance and reinsurance solutions for complex risks and claims. Backed by a strong academic foundation and extensive industry experience, Anuraag now provides independent advisory services to help corporate clients navigate complex challenges, strengthen risk protection and secure appropriate coverage.',
    ],
  },
  {
    name: 'Swapnil Trivedy',
    role: 'Consultant — Kenya · Risk Advisory & Market Relations',
    image: swapnilTrivedy,
    badge: '',
    location: 'Kenya',
    contacts: [
      { href: 'tel:+254713843333', label: '+254 713 843333' },
      { href: 'mailto:swapnil.trivedy@willmarsre.com', label: 'swapnil.trivedy@willmarsre.com' },
    ],
    paragraphs: [
      'An insurance and business leader with more than a decade of executive experience in Kenya and across multi-market operations. Swapnil brings practical expertise in underwriting, claims, corporate risk advisory, client relationships and market development, supporting WillMars’ Kenya engagements with risk insight and market coordination.',
    ],
  },
  {
    name: 'Chandrasekaran Ramakrishnan',
    role: 'Senior Reinsurance Advisor',
    image: chandrasekaranRamakrishnan,
    badge: '',
    location: '',
    contacts: [
      { href: 'tel:+919940086111', label: '+91 99400 86111' },
      { href: 'mailto:r.chandrasekaran@willmarsre.com', label: 'r.chandrasekaran@willmarsre.com' },
    ],
    paragraphs: [
      'Chandrasekaran Ramakrishnan is a distinguished insurance and reinsurance professional with 49 years of experience spanning underwriting, reinsurance, product development, finance, audit and professional training. He has served as an insurance and reinsurance technical consultant since 2017 and brings strong influence and extensive relationships across the Indian insurance market.',
      'During his career, he has held senior positions with Kotak Mahindra General Insurance, Math Re Insurance Brokers, Cholamandalam MS General Insurance, Royal Sundaram Alliance Insurance, Reliance Insurance Tanzania, Kenindia Assurance Company and The New India Assurance Company. His international experience includes leadership responsibilities across India, Mauritius, Tanzania, Kenya, the Middle East and Singapore.',
      'He served on an IRDAI-appointed committee reviewing regulations relating to reinsurance, investments, foreign reinsurance branches and Lloyd’s India. He was also a member of the IRDAI Reinsurance Advisory Committee from 2022 to 2025. A Fellow Chartered Accountant and Fellow of the Insurance Institute of India, he also holds ACII, DIRM and Diploma in Business Management qualifications.',
    ],
  },
  {
    name: 'Babu Paul T.',
    role: 'Senior Advisor',
    image: babuPaul,
    badge: '',
    location: '',
    contacts: [
      { href: 'tel:+919886863750', label: '+91 98868 63750' },
      { href: 'mailto:babu.paul@willmarsre.com', label: 'babu.paul@willmarsre.com' },
    ],
    paragraphs: [
      'Bringing 42 years of industry experience, Babu is a former Executive Director and General Manager at National Insurance Company Limited. He spent approximately five years as Managing Director & CEO of India International Insurance Pte Ltd in Singapore, an insurer active in reinsurance and rated A− for financial strength by S&P Global Ratings. A Fellow of the Insurance Institute of India with an MBA in Marketing, he brings strategic insight to the organisation’s advisory and growth capabilities.',
    ],
  },
  {
    name: 'Kaushiki Kaul',
    role: 'Intern — Research & Coordination',
    image: kaushikiKaul,
    badge: '',
    location: '',
    contacts: [
      { href: 'mailto:intern@willmarsre.com', label: 'intern@willmarsre.com' },
    ],
    paragraphs: [
      'With a background in the development and social-impact sector, Kaushiki has gained experience in research, documentation, community outreach and programme coordination through organisations including EnAble India, Ramagya Group, the National Skill Development Corporation and Jagori Rural Charitable Trust. She also serves as the Principal Officer of Lotus Insurance and Financial Services Private Limited. At WillMars, she supports the engagement team with research, documentation, field and programme coordination, and administrative support throughout the placement process.',
    ],
  },
]

function contactByType(contacts, type) {
  const match = contacts.find((item) => item.href.startsWith(`${type}:`))
  return match ? match.label : ''
}

function contactHrefByType(contacts, type) {
  const match = contacts.find((item) => item.href.startsWith(`${type}:`))
  return match ? match.href : ''
}

function MetaIcon({ type }) {
  if (type === 'phone') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.5 4h3l1.5 4-2 1.2a12 12 0 0 0 5.8 5.8L17 13l4 1.5v3A2 2 0 0 1 19 20C10.7 20 4 13.3 4 5a2 2 0 0 1 2-1z" />
      </svg>
    )
  }
  if (type === 'email') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="M3 7l9 6 9-6" />
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21s7-4.5 7-10a7 7 0 1 0-14 0c0 5.5 7 10 7 10z" />
      <circle cx="12" cy="11" r="2.5" />
    </svg>
  )
}

function ProfilePhoto({ profile, className = 'profile-photo' }) {
  if (profile.image) {
    const style = {}
    if (profile.imagePosition) style.objectPosition = profile.imagePosition
    if (profile.imageTranslateY != null) {
      style['--photo-offset-y'] = `${profile.imageTranslateY}px`
      style['--photo-extra-height'] = `${Math.abs(profile.imageTranslateY)}px`
    }
    const offsetClass = profile.imageTranslateY != null ? ' profile-photo--offset-y' : ''
    return (
      <img
        className={`${className}${offsetClass}`}
        src={profile.image}
        alt={profile.name}
        style={Object.keys(style).length ? style : undefined}
      />
    )
  }

  return (
    <div className="photo-placeholder" aria-label={`Photograph space reserved for ${profile.name}`}>
      <span>{profile.initials}</span>
    </div>
  )
}

function buildMetaRows(profile, variant) {
  const location = profile.location?.trim() || ''

  if (variant === 'detail') {
    const rows = []
    profile.contacts.forEach((contact) => {
      if (contact.href.startsWith('tel:')) {
        rows.push({ type: 'phone', label: contact.label, href: contact.href })
      } else if (contact.href.startsWith('mailto:')) {
        rows.push({ type: 'email', label: contact.label, href: contact.href })
      }
    })
    if (location) {
      rows.push({ type: 'location', label: location, href: '' })
    }
    return rows
  }

  const phone = contactByType(profile.contacts, 'tel')
  const email = contactByType(profile.contacts, 'mailto')
  const phoneHref = contactHrefByType(profile.contacts, 'tel')
  const emailHref = contactHrefByType(profile.contacts, 'mailto')

  return [
    { type: 'phone', label: phone, href: phoneHref },
    { type: 'email', label: email, href: emailHref },
    { type: 'location', label: location, href: '' },
  ].filter((row) => row.label)
}

function ProfileMeta({ profile, variant = 'card' }) {
  const rows = buildMetaRows(profile, variant)

  if (rows.length === 0) {
    return null
  }

  return (
    <ul className={`profile-meta profile-meta--${variant}`}>
      {rows.map((row) => (
        <li key={row.href || `${row.type}-${row.label}`} className="has-value">
          <span className="profile-meta-icon">
            <MetaIcon type={row.type} />
          </span>
          {row.href ? (
            <a href={row.href}>{row.label}</a>
          ) : (
            <span>{row.label}</span>
          )}
        </li>
      ))}
    </ul>
  )
}

function Leadership() {
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [insertAfter, setInsertAfter] = useState(null)
  const gridRef = useRef(null)
  const panelRef = useRef(null)

  useLayoutEffect(() => {
    const grid = gridRef.current
    if (!grid || selectedIndex == null) {
      setInsertAfter(null)
      return undefined
    }

    const measure = () => {
      const cards = [...grid.querySelectorAll(':scope > .profile-card')]
      const selected = cards.find((card) => Number(card.dataset.index) === selectedIndex)
      if (!selected) {
        setInsertAfter(null)
        return
      }

      const rowTop = selected.offsetTop
      let last = selectedIndex
      cards.forEach((card) => {
        const cardIndex = Number(card.dataset.index)
        if (Math.abs(card.offsetTop - rowTop) <= 2) last = Math.max(last, cardIndex)
      })
      setInsertAfter((current) => (current === last ? current : last))
    }

    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(grid)
    return () => observer.disconnect()
  }, [selectedIndex])

  useEffect(() => {
    if (selectedIndex == null || !panelRef.current) return
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    panelRef.current.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' })
  }, [selectedIndex, insertAfter])

  function toggleProfile(index) {
    setSelectedIndex((current) => (current === index ? null : index))
  }

  const selected = selectedIndex == null ? null : profiles[selectedIndex]

  return (
    <section className="leadership leadership-v2" id="leadership">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Leadership</div>
          <h2>
            <span className="intro-title-line">Expertise across</span>
            <span className="intro-title-line">markets.</span>
          </h2>
          <p>WillMars Reinsurance Brokers brings together local leadership and senior international expertise across primary insurance, reinsurance, regulation and complex-risk advisory.</p>
        </div>

        <div className="team-grid leadership-grid" ref={gridRef}>
          {profiles.map((profile, index) => (
            <ProfileSlot
              key={profile.name}
              profile={profile}
              index={index}
              selected={selectedIndex === index}
              showPanel={selected && insertAfter === index}
              panelRef={panelRef}
              onToggle={toggleProfile}
              onClose={() => setSelectedIndex(null)}
              selectedProfile={selected}
            />
          ))}
        </div>

        
      </div>
    </section>
  )
}

function ProfileSlot({ profile, index, selected, showPanel, panelRef, onToggle, onClose, selectedProfile }) {
  return (
    <>
      <article
        className={selected ? 'profile-card is-selected' : 'profile-card'}
        data-index={index}
      >
        <div className="profile-card-media">
          {profile.badge ? <span className="profile-card-badge">{profile.badge}</span> : null}
          <ProfilePhoto profile={profile} />
        </div>
        <div className="profile-copy">
          <h3>{profile.name}</h3>
          <div className="role">{profile.role}</div>
          <ProfileMeta profile={profile} variant="card" />
          <button
            className="profile-view-link"
            type="button"
            aria-expanded={selected}
            aria-controls={selected ? 'profile-detail' : undefined}
            onClick={() => onToggle(index)}
          >
            View profile
          </button>
        </div>
      </article>
      {showPanel && (
        <div className="profile-detail profile-detail-v2" id="profile-detail" ref={panelRef}>
          <button className="profile-detail-close" type="button" aria-label="Close profile" onClick={onClose}>
            ×
          </button>
          <div className="profile-detail-main">
            <ProfilePhoto profile={selectedProfile} className="profile-photo profile-detail-photo" />
            <div className="profile-detail-copy">
              <h3>{selectedProfile.name}</h3>
              <div className="role">{selectedProfile.role}</div>
              <ProfileMeta profile={selectedProfile} variant="detail" />
              {selectedProfile.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Leadership
